<template>
    <card>
        <h3>{{$t('common.name')}}: {{address.name}}</h3>
        <b>{{$t('form.address.country')}}: </b> <span>{{address.location.country}}</span>
        <br />
        <b>{{$t('common.location.address')}}: </b> <span>{{address.location.address}}, {{address.location.number}}</span>
        <br />
        <b>{{$t('common.location.city')}}: </b> <span>{{address.location.city}}</span>
        <br />
        <b>{{$t('common.location.neighborhood')}}: </b> <span>{{address.location.neighborhood}}</span>
        <br />
        <b>{{$t('common.location.state')}}: </b> <span>{{address.location.state}}</span>
        <br />
        <span v-if="address.location.info">
            <b>{{$t('common.location.info')}}: </b> <span>{{address.location.info}}</span>
            <br />
        </span>
        <b>{{$t('common.location.zip_code')}}: </b> <span>{{address.location.zip}}</span>
        <br />
    </card>
</template>

<script>
import Card from '../../argon/components/Cards/Card'
export default {
    name: 'ProfileAddress',
    components: {
        Card
    },
    props: {
        address: {
            type: Object,
            required: true
        }
    }

}
</script>

<style>

</style>
